












// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import { getDefaultAloContact, AloContact } from '@/models/alo/AloContact';

@Component({
  name: 'ReadContent',    
   props: {
    contact:{      
      default:getDefaultAloContact()
    },
    loading:{
      type:Boolean,
      default:false
    }
  }
})
export default class ReadContent extends Vue {
  private contact!:AloContact
  private loading!:boolean


  get configuration(){
    return this.$store.myGetters.configuration
  }

  get activityDic(){
    return this.$store.myGetters.activityDic
  }

  created() {
    this.$store.myActions.ADM_ACTIVITY_ENSURE()    
  }

}
